import { render, staticRenderFns } from "./HeaderDiscountCodeDialog.vue?vue&type=template&id=040a8e82&"
import script from "./HeaderDiscountCodeDialog.vue?vue&type=script&lang=js&"
export * from "./HeaderDiscountCodeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports